<template>
	<div class="right_content_container">
		<div class="flex_between">
			<div class="left_title">热门回复</div>
			<div v-if="replyData.length < 10" @click="showAddDialog" class="add_btn flex_center">
				<p style="margin-top: -2px">+&nbsp;</p>
				<p>添加回复</p>
			</div>
		</div>

		<div v-if="replyData.length > 0" class="table_plate">
			<div class="hot_item flex_center" style="justify-content: flex-start">
				<p>标题</p>
				<p>内容</p>
				<span style="opacity: 0">编辑</span>
				<span style="opacity: 0">删除</span>
			</div>

			<div
				v-for="(item, index) in replyData"
				:key="item.id"
				class="hot_item flex_center"
				style="justify-content: flex-start; margin-top: 10px; align-items: center"
			>
				<div style="display: flex; flex: 1">
					<div class="item_border">{{ item.title }}</div>
					<div class="item_border" v-html="item.content"></div>
				</div>
				<el-button type="primary" @click="replyAction('edit', item)" style="margin-right: 5px"
					>编辑</el-button
				>
				<el-dropdown class="example-showcase">
					<span class="el-dropdown-link">
						排序
					</span>
					<template #dropdown>
						<el-dropdown-menu>
							<el-dropdown-item :disabled="index === 0" @click="moveItem(index, -1)">
								上移
							</el-dropdown-item>
							<el-dropdown-item
								:disabled="index === replyData.length - 1"
								@click="moveItem(index, 1)"
							>
								下移
							</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
				<span v-throttle="() => replyAction('delete', item)">删除</span>
			</div>
		</div>

		<div v-else class="global_none_data">
			<div class="flex_center">
				<img src="../assets/none_thing/none_answer_image.png" />
			</div>
			<p>暂无问答</p>
		</div>

		<el-dialog
			v-model="centerDialogVisible"
			title=""
			:close-on-click-modal="false"
			:show-close="false"
			center
			style="padding: 40px; padding-bottom: 20px"
		>
			<template #header>
				<p class="dialog_title">{{ dialogTitle }}</p>
			</template>
			<div class="dialog_content">
				<p style="font-size: 14px; color: #606266">问题</p>
				<el-input
					v-model="textarea"
					style="margin-left: 20px; width: 60%"
					:rows="3"
					type="textarea"
					placeholder="请输入标题"
					:maxlength="100"
					@blur="checkoutValue"
					show-word-limit
				/>
			</div>
			<div class="dialog_content" style="margin-top: 20px; margin-bottom: 5px">
				<p style="font-size: 14px; color: #606266;margin-right: 20px;">回答</p>
				<div style="flex: 1;">
					<textarea v-model="context" class="inputTextarea" maxlength="1000" placeholder="请输入回答" v-if="centerDialogVisible"> </textarea>
				</div>
			</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="centerDialogVisible = false">取消</el-button>
					<el-button type="primary" v-throttle="saveData"> 保存 </el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { post, get, deleteRe, put } from "../utils/request";
import QuillEditor from "./quill_editor.vue";
import { message } from "@/utils/resetMessage";
const { proxy } = getCurrentInstance();
const centerDialogVisible = ref(false);
const textarea = ref("");
const context = ref("");
const replyData = ref([]);
const replyId = ref("");
const dialogTitle = ref("新增热门回复");

onMounted(() => {
	getHotReply();
});

const checkoutValue = () => {
	textarea.value = textarea.value.replace(/^\s+|\s+$/g, "");
};
const moveItem = (index, direction) => {
	const list = JSON.parse(JSON.stringify(replyData.value)); // 或从参数、闭包中获取
	const targetIndex = index + direction;
	[list[index], list[targetIndex]] = [list[targetIndex], list[index]];
	const idList = list.map((item) => item.id);
	post("/api-cms/reply/turn", { idList })
		.then((res) => {
			if (res.code === 1) {
				getHotReply();
			} else {
				message.error("排序更新失败");
			}
		})
		.catch((error) => {
			message.error("排序更新失败");
		});
};
// 获取热门回复
const getHotReply = () => {
	get("/api-cms/reply/hot", {})
		.then((res) => {
			// console.log(res);
			if (res.code === 1) {
				replyData.value = res.result;
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

// 删除回复
const replyAction = (type, data) => {
	if (type === "edit") {
		textarea.value = data.title;
		context.value = data.content;
		replyId.value = data.id;
		dialogTitle.value = "编辑热门回复";
		centerDialogVisible.value = true;
	} else {
		deleteRe("/api-cms/reply/hot/" + data.id, {})
			.then((res) => {
				if (res.code === 1) {
					message.success("删除成功");
					getHotReply();
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
};

const showAddDialog = () => {
	textarea.value = "";
	context.value = "";
	replyId.value = "";
	dialogTitle.value = "新增热门回复";
	centerDialogVisible.value = true;
};

// 输入框为空校验
const saveData = () => {
	if (!textarea.value) {
		proxy.$message({
			message: "请输入标题",
			type: "error",
		});

		return;
	}

	if (!context.value) {
		proxy.$message({
			message: "请输入回答",
			type: "error",
		});

		return;
	}

	addHotReply();
};

// 新增/编辑回复
const addHotReply = () => {
	let hotParams;
	if (replyId.value) {
		hotParams = {
			id: replyId.value,
			title: textarea.value,
			content: context.value,
		};
	} else {
		hotParams = {
			title: textarea.value,
			content: context.value,
		};
	}

	post("/api-cms/reply/hot", hotParams)
		.then((res) => {
			// console.log(res);
			if (res.code === 1) {
				centerDialogVisible.value = false;
				message.success("保存成功");
				getHotReply();
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
//排序

const getEditorContent = (item) => {
	context.value = item;
};
</script>

<style scoped lang="less">
.hot_item {
	width: 80%;
	p {
		flex: 1;
		font-size: 14px;
		color: #000000;
		margin-right: 20px;
	}
	.item_border {
		padding: 5px 10px;
		border-radius: 4px;
		margin-right: 20px;
		position: relative;
		flex: 1;
		&::after {
			content: "";
			width: 100%;
			height: 100%;
			border-radius: 4px;
			border: 1px #dcdfe6 solid;
			position: absolute;
			top: -1px;
			left: 0;
		}
	}
	span {
		padding: 5px 10px;
		border-radius: 4px;
		font-size: 14px;
		color: #ff4040;
		cursor: pointer;
	}
}
.dialog_content {
	display: flex;
	align-items: flex-start;
}
.example-showcase .el-dropdown-link {
	cursor: pointer;
	color: #A15BFF;
	display: flex;
	align-items: center;
}
.el-dropdown .el-tooltip__trigger:focus-visible {
	outline: none;
}
.inputTextarea {
	width: 100%;
	// height: 100%;
	min-height: 200px;
	border-radius: 4px;
	border: 1px solid #dcdfe6;
	padding: 10px;
	font-size: 14px;
	resize: none;
	outline: none;
	line-height: 20px;
}
.inputTextarea::placeholder {
  color: #878399;
  font-size: 14px;
}
</style>
